import { defineMessages } from 'react-intl';

export default defineMessages({
    loadingNextWizardStepMessage: {
        id: 'quoteandbind.ea.wizard.Loading next wizard step...',
        defaultMessage: 'Loading next wizard step...'
    },
    policyDetails: {
        id: 'quoteandbind.wizard.step.Policy Details',
        defaultMessage: 'Policy Details'
    },
    exitTransaction: {
        id: 'quoteandbind.wizard.step.Exit Transaction?',
        defaultMessage: 'Exit Transaction?'
    },
    cancelLabel: {
        id: 'quoteandbind.wizard.step.Cancel',
        defaultMessage: 'Cancel'
    },
    exitLabel: {
        id: 'quoteandbind.wizard.step.Exit',
        defaultMessage: 'Exit'
    },
    infoWillBeSavedAsDraft: {
        id: 'quoteandbind.wizard.step.Information entered on prior pages will be saved as a draft. Any outstanding changes on this page will be lost.',
        defaultMessage: 'Information entered on prior pages will be saved as a draft. Any outstanding changes on this page will be lost.'
    },
    anErrorOccurred: {
        id: 'quoteandbind.ea.wizard.error.cancel',
        defaultMessage: 'Something went wrong during this process.'
    },
    anErrorOccurredTitle: {
        id: 'quoteandbind.ea.wizard.error.cancel.title',
        defaultMessage: 'Error'
    },
    saveQuoteError: {
        id: 'quoteandbind.ea.wizard.Unable to quote',
        defaultMessage: 'Unable to quote'
    },
    saveQuoteErrorMessage: {
        id: 'quoteandbind.ea.wizard.An error occurred while attempting to quote.',
        defaultMessage: 'An error occurred while attempting to quote.'
    },
    // Inline change for step tab
    coverages: {
        id: 'quoteandbind.wizard.step.Coverages',
        defaultMessage: 'Coverages'
    }
});
